require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./button"), require("./svgicon"), require("./utils"));
	else if(typeof define === 'function' && define.amd)
		define(["./button", "./svgicon", "./utils"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./button"), require("./svgicon"), require("./utils")) : factory(root["./button"], root["./svgicon"], root["./utils"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(globalThis, (__WEBPACK_EXTERNAL_MODULE__32477__, __WEBPACK_EXTERNAL_MODULE__56685__, __WEBPACK_EXTERNAL_MODULE__78815__) => {
return (globalThis["wpBaUiCarbonToolkit"] = globalThis["wpBaUiCarbonToolkit"] || []).push([[7653],{

/***/ 91147:
/***/ ((module) => {

var amdi18n={"__root":{"back":"Back"},"__cs":{"back":"Zpět"},"__da":{"back":"Tilbage"},"__de":{"back":"Zurück"},"__es":{"back":"Atrás"},"__fi":{"back":"Edellinen"},"__fr":{"back":"Précédent"},"__hr":{"back":"Natrag"},"__hu":{"back":"Vissza"},"__it":{"back":"Indietro"},"__ja":{"back":"戻る"},"__kk":{"back":"Артқа"},"__ko":{"back":"이전"},"__nb":{"back":"Tilbake"},"__nl":{"back":"Terug"},"__no":{"back":"Tilbake"},"__pl":{"back":"Wstecz"},"__pt":{"back":"Voltar"},"__pt-br":{"back":"Voltar"},"__ro":{"back":"Înapoi"},"__ru":{"back":"Назад"},"__sl":{"back":"Nazaj"},"__sv":{"back":"Föregående"},"__th":{"back":"ย้อนกลับ"},"__tr":{"back":"Geri"},"__zh":{"back":"后退"},"__zh-cn":{"back":"后退"},"__zh-hk":{"back":"上一步"},"__zh-mo":{"back":"上一步"},"__zh-sg":{"back":"后退"},"__zh-tw":{"back":"上一步"}};amdi18n.init=function(language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;

/***/ }),

/***/ 46094:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(__webpack_require__(38213));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(68779));
var _react = _interopRequireWildcard(__webpack_require__(16689));
var _propTypes = _interopRequireDefault(__webpack_require__(580));
var _button = _interopRequireDefault(__webpack_require__(32477));
var _svgicon = _interopRequireDefault(__webpack_require__(56685));
var _arrowLeft_ = _interopRequireDefault(__webpack_require__(70051));
var _utils = __webpack_require__(78815);
var _backbutton = _interopRequireDefault(__webpack_require__(54800));
var _StringResource = _interopRequireDefault(__webpack_require__(77571));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019, 2021
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

const backButtonClassName = _backbutton.default.backButtonClassName.replace(/"/g, '');
const {
  sanitize,
  getInheritedProps
} = _utils.propsUtils;
function getString(value) {
  return _StringResource.default.get(value);
}
class BackButton extends _react.Component {
  constructor() {
    super(...arguments);
    (0, _defineProperty2.default)(this, "_ref", node => {
      this._button = node;
    });
  }
  focus() {
    this._button && this._button.focus();
  }
  render() {
    const {
      buttonType,
      className,
      style,
      getLocaleString,
      label,
      ...others
    } = this.props;
    const dir = _utils.Bidi.resolveDir(this.props.label || '', this.props.dir);
    const classNames = (0, _utils.classnames)(backButtonClassName, {
      [`${buttonType}`]: buttonType
    });
    const buttonPassthroughProps = getInheritedProps(others, _button.default);
    const _label = label || getLocaleString('back'); // eslint-disable-line no-underscore-dangle
    const otherProps = label ? {
      children: label
    } : {
      hasIconOnly: true,
      iconDescription: _label
    };
    return /*#__PURE__*/_react.default.createElement("div", {
      className: `${classNames} ${className}`,
      dir: dir,
      style: style
    }, /*#__PURE__*/_react.default.createElement(_button.default, (0, _extends2.default)({
      "aria-label": _label
    }, sanitize(others, BackButton), buttonPassthroughProps, otherProps, {
      kind: "ghost",
      size: "small",
      renderIcon: props => /*#__PURE__*/_react.default.createElement(_svgicon.default, (0, _extends2.default)({
        icon: _arrowLeft_.default
      }, props)),
      ref: this._ref
    })));
  }
}
exports["default"] = BackButton;
(0, _defineProperty2.default)(BackButton, "propTypes", {
  ..._button.default.propTypes,
  buttonType: _propTypes.default.oneOf(['standard', 'label', 'nav_pane']),
  dir: _propTypes.default.oneOf(['', 'ltr', 'rtl', 'auto']),
  label: _propTypes.default.string,
  textDir: _propTypes.default.oneOf(['', 'ltr', 'rtl', 'auto']),
  pageTextDir: _propTypes.default.oneOf(['', 'ltr', 'rtl', 'auto']),
  numShape: _propTypes.default.bool,
  pageNumShape: _propTypes.default.bool,
  className: _propTypes.default.string,
  style: _propTypes.default.object,
  getLocaleString: _propTypes.default.func
});
(0, _defineProperty2.default)(BackButton, "defaultProps", {
  getLocaleString: getString,
  buttonType: 'standard',
  className: '',
  style: {}
});

/***/ }),

/***/ 76854:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
var _BackButton = _interopRequireDefault(__webpack_require__(46094));
exports["default"] = _BackButton.default;
exports.BackButton = _BackButton.default;

/***/ }),

/***/ 77571:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
exports["default"] = void 0;
var _utils = __webpack_require__(78815);
var _BackButtonResources = _interopRequireDefault(__webpack_require__(91147));
/* IBM Confidential
*
* OCO Source Materials
*
* IBM Cognos Products: ba-ui-toolkit
* (C) Copyright IBM Corp. 2019
*
* The source code for this program is not published or otherwise
* divested of its trade secrets, irrespective of what has been
* deposited with the U.S. Copyright Office.
* NLS_ENCODING=UTF-8
* NLS_MESSAGEFORMAT_NONE
*/
// eslint-disable-line
var _default = exports["default"] = new _utils.StringResource(_BackButtonResources.default);

/***/ }),

/***/ 99100:
/***/ ((module, exports, __webpack_require__) => {

exports = module.exports = __webpack_require__(98060)(false);
// imports


// module
exports.push([module.id, ".ba-backbutton{display:inline-block;position:relative}.ba-backbutton .ba-common-button.is-variant_frameless{background-color:transparent;padding:0}.ba-backbutton .ba-common-button.is-variant_frameless .ba-common-button__icon.is-left{padding:0}.ba-backbutton .ba-common-button.is-variant_frameless.is-hover:not(.is-disabled),.ba-backbutton .ba-common-button.is-variant_frameless:hover:not(.is-disabled):not(.is-tap){background-color:transparent}.ba-backbutton.is-standard .ba-common-button{height:40px;font-size:1.5rem;font-weight:600}.ba-backbutton.is-standard .ba-common-button.is-variant_frameless .ba-common-button__layout{overflow:visible}.ba-backbutton.is-standard .ba-common-button.is-variant_frameless .ba-common-button__layout .ba-common-button__icon.is-left svg{border-radius:100%;overflow:visible;width:18px;height:18px;padding:5px}.ba-backbutton.is-label .ba-common-button{height:32px;font-size:1rem}.ba-backbutton.is-label .ba-common-button.is-variant_frameless .ba-common-button__layout{overflow:visible;line-height:1}.ba-backbutton.is-label .ba-common-button.is-variant_frameless .ba-common-button__layout .ba-common-button__icon.is-left svg{width:24px;height:24px}.ba-backbutton.is-label .ba-common-button.is-variant_frameless .ba-common-button__layout .ba-common-button__label{line-height:1.25rem;text-align:left}.ba-backbutton.is-nav_pane .ba-common-button{height:32px;width:32px}[dir=rtl] .ba-backbutton.is-standard .ba-common-button.is-variant_frameless .ba-common-button__icon.is-left{margin-left:8px;margin-right:unset}[dir=rtl] .ba-backbutton.is-label .ba-common-button.is-variant_frameless .ba-common-button__icon.is-left{margin-left:8px;margin-right:unset}[dir=ltr] .ba-backbutton.is-standard .ba-common-button.is-variant_frameless .ba-common-button__icon.is-left,.ba-backbutton.is-standard .ba-common-button.is-variant_frameless .ba-common-button__icon.is-left{margin-right:8px;margin-left:unset}[dir=ltr] .ba-backbutton.is-label .ba-common-button.is-variant_frameless .ba-common-button__icon.is-left,.ba-backbutton.is-label .ba-common-button.is-variant_frameless .ba-common-button__icon.is-left{margin-right:8px;margin-left:unset}[dir=rtl].ba-backbutton.is-standard .ba-common-button.is-variant_frameless .ba-common-button__layout .ba-common-button__icon.is-left{margin-left:8px;margin-right:inherit}[dir=rtl].ba-backbutton.is-label .ba-common-button.is-variant_frameless .ba-common-button__layout .ba-common-button__icon.is-left{margin-left:8px;margin-right:inherit}[dir=rtl].ba-backbutton.is-label .ba-common-button.is-variant_frameless .ba-common-button__layout .ba-common-button__label{text-align:right}[dir=rtl].ba-backbutton svg{transform:rotate(180deg)}.ba-backbutton.is-nav_pane .ba-common-button{height:32px}.ba-backbutton.is-nav_pane .ba-common-button.is-variant_frameless{color:#595859}.ba-backbutton.is-nav_pane .ba-common-button.is-variant_frameless.is-hover:not(.is-disabled),.ba-backbutton.is-nav_pane .ba-common-button.is-variant_frameless:hover:not(.is-disabled):not(.is-tap){color:#0f62fe;color:hsla(var(--interactive-01-h, 219.1631799163), var(--interactive-01-s, 99.1701244813%), var(--interactive-01-l, 52.7450980392%), 1)}.ba-backbutton.is-nav_pane .ba-common-button.is-variant_frameless.is-active:not(.is-disabled),.ba-backbutton.is-nav_pane .ba-common-button.is-variant_frameless:active:not(.is-disabled):not(.is-tap){color:#0f62fe;color:hsla(var(--interactive-01-h, 219.1631799163), var(--interactive-01-s, 99.1701244813%), var(--interactive-01-l, 52.7450980392%), 1);background-color:transparent}.ba-backbutton.is-label .ba-common-button.is-variant_frameless .ba-common-button__layout .ba-common-button__icon.is-left svg{transition:color .2s ease-in-out;color:#0f62fe;color:hsla(var(--interactive-01-h, 219.1631799163), var(--interactive-01-s, 99.1701244813%), var(--interactive-01-l, 52.7450980392%), 1)}.ba-backbutton.is-label .ba-common-button.is-variant_frameless .ba-common-button__layout .ba-common-button__label{color:#343334}.ba-backbutton.is-label .ba-common-button.is-variant_frameless.is-hover:not(.is-disabled) .ba-common-button__icon.is-left svg,.ba-backbutton.is-label .ba-common-button.is-variant_frameless:hover:not(.is-disabled):not(.is-tap) .ba-common-button__icon.is-left svg{color:#002d9c;color:hsla(var(--active-primary-h, 222.6923076923), var(--active-primary-s, 100%), var(--active-primary-l, 30.5882352941%), 1)}.ba-backbutton.is-label .ba-common-button.is-variant_frameless.is-active:not(.is-disabled),.ba-backbutton.is-label .ba-common-button.is-variant_frameless:active:not(.is-disabled):not(.is-tap){background-color:transparent}.ba-backbutton.is-label .ba-common-button.is-variant_frameless.is-active:not(.is-disabled) .ba-common-button__icon .ba-common-svgIcon,.ba-backbutton.is-label .ba-common-button.is-variant_frameless:active:not(.is-disabled):not(.is-tap) .ba-common-button__icon .ba-common-svgIcon{color:#002d9c;color:hsla(var(--active-primary-h, 222.6923076923), var(--active-primary-s, 100%), var(--active-primary-l, 30.5882352941%), 1)}.ba-backbutton.is-label .ba-common-button.is-disabled .ba-common-button__layout .ba-common-button__icon.is-left svg{color:#0f62fe;color:hsla(var(--interactive-01-h, 219.1631799163), var(--interactive-01-s, 99.1701244813%), var(--interactive-01-l, 52.7450980392%), 1)}.ba-backbutton.is-standard .ba-common-button.is-variant_frameless .ba-common-button__layout .ba-common-button__icon.is-left svg{transition:color .2s ease-in-out,border-color .2s ease-in-out,background-color .2s ease-in-out;border:2px solid;color:#0f62fe;color:hsla(var(--interactive-01-h, 219.1631799163), var(--interactive-01-s, 99.1701244813%), var(--interactive-01-l, 52.7450980392%), 1)}.ba-backbutton.is-standard .ba-common-button.is-variant_frameless .ba-common-button__layout .ba-common-button__label{font-size:1.5rem;line-height:2.1875rem;color:#343334}.ba-backbutton.is-standard .ba-common-button.is-variant_frameless.is-hover:not(.is-disabled) .ba-common-button__icon.is-left svg,.ba-backbutton.is-standard .ba-common-button.is-variant_frameless:hover:not(.is-disabled):not(.is-tap) .ba-common-button__icon.is-left svg{background-color:#002d9c;background-color:hsla(var(--active-primary-h, 222.6923076923), var(--active-primary-s, 100%), var(--active-primary-l, 30.5882352941%), 1);border-color:#002d9c;border-color:hsla(var(--active-primary-h, 222.6923076923), var(--active-primary-s, 100%), var(--active-primary-l, 30.5882352941%), 1);color:#fff}.ba-backbutton.is-standard .ba-common-button.is-variant_frameless.is-active:not(.is-disabled),.ba-backbutton.is-standard .ba-common-button.is-variant_frameless:active:not(.is-disabled):not(.is-tap){background-color:transparent}.ba-backbutton.is-standard .ba-common-button.is-variant_frameless.is-active:not(.is-disabled) .ba-common-button__icon.is-left svg,.ba-backbutton.is-standard .ba-common-button.is-variant_frameless:active:not(.is-disabled):not(.is-tap) .ba-common-button__icon.is-left svg{background-color:#002d9c;background-color:hsla(var(--active-primary-h, 222.6923076923), var(--active-primary-s, 100%), var(--active-primary-l, 30.5882352941%), 1);border-color:#002d9c;border-color:hsla(var(--active-primary-h, 222.6923076923), var(--active-primary-s, 100%), var(--active-primary-l, 30.5882352941%), 1);color:#fff}", ""]);

// exports
exports.locals = {
	"backButtonClassName": "\"ba-backbutton\""
};

/***/ }),

/***/ 54800:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93379);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7795);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90569);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3565);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19216);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44589);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_backbutton_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99100);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_backbutton_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_backbutton_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony reexport (unknown) */ var __WEBPACK_REEXPORT_OBJECT__ = {};
/* harmony reexport (unknown) */ for(const __WEBPACK_IMPORT_KEY__ in _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_backbutton_scss__WEBPACK_IMPORTED_MODULE_6__) if(__WEBPACK_IMPORT_KEY__ !== "default") __WEBPACK_REEXPORT_OBJECT__[__WEBPACK_IMPORT_KEY__] = () => _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_backbutton_scss__WEBPACK_IMPORTED_MODULE_6__[__WEBPACK_IMPORT_KEY__]
/* harmony reexport (unknown) */ __webpack_require__.d(__webpack_exports__, __WEBPACK_REEXPORT_OBJECT__);

      
      
      
      
      
      
      
      
      

var options = {};

options.styleTagTransform = (_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default());
options.setAttributes = (_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default());

      options.insert = _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default().bind(null, "head");
    
options.domAPI = (_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default());
options.insertStyleElement = (_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default());

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()((_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_backbutton_scss__WEBPACK_IMPORTED_MODULE_6___default()), options);




       /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_backbutton_scss__WEBPACK_IMPORTED_MODULE_6___default()) && (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_backbutton_scss__WEBPACK_IMPORTED_MODULE_6___default().locals) ? (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_backbutton_scss__WEBPACK_IMPORTED_MODULE_6___default().locals) : undefined);


/***/ }),

/***/ 93379:
/***/ ((module) => {

"use strict";


var stylesInDOM = [];
function getIndexByIdentifier(identifier) {
  var result = -1;
  for (var i = 0; i < stylesInDOM.length; i++) {
    if (stylesInDOM[i].identifier === identifier) {
      result = i;
      break;
    }
  }
  return result;
}
function modulesToDom(list, options) {
  var idCountMap = {};
  var identifiers = [];
  for (var i = 0; i < list.length; i++) {
    var item = list[i];
    var id = options.base ? item[0] + options.base : item[0];
    var count = idCountMap[id] || 0;
    var identifier = "".concat(id, " ").concat(count);
    idCountMap[id] = count + 1;
    var indexByIdentifier = getIndexByIdentifier(identifier);
    var obj = {
      css: item[1],
      media: item[2],
      sourceMap: item[3],
      supports: item[4],
      layer: item[5]
    };
    if (indexByIdentifier !== -1) {
      stylesInDOM[indexByIdentifier].references++;
      stylesInDOM[indexByIdentifier].updater(obj);
    } else {
      var updater = addElementStyle(obj, options);
      options.byIndex = i;
      stylesInDOM.splice(i, 0, {
        identifier: identifier,
        updater: updater,
        references: 1
      });
    }
    identifiers.push(identifier);
  }
  return identifiers;
}
function addElementStyle(obj, options) {
  var api = options.domAPI(options);
  api.update(obj);
  var updater = function updater(newObj) {
    if (newObj) {
      if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap && newObj.supports === obj.supports && newObj.layer === obj.layer) {
        return;
      }
      api.update(obj = newObj);
    } else {
      api.remove();
    }
  };
  return updater;
}
module.exports = function (list, options) {
  options = options || {};
  list = list || [];
  var lastIdentifiers = modulesToDom(list, options);
  return function update(newList) {
    newList = newList || [];
    for (var i = 0; i < lastIdentifiers.length; i++) {
      var identifier = lastIdentifiers[i];
      var index = getIndexByIdentifier(identifier);
      stylesInDOM[index].references--;
    }
    var newLastIdentifiers = modulesToDom(newList, options);
    for (var _i = 0; _i < lastIdentifiers.length; _i++) {
      var _identifier = lastIdentifiers[_i];
      var _index = getIndexByIdentifier(_identifier);
      if (stylesInDOM[_index].references === 0) {
        stylesInDOM[_index].updater();
        stylesInDOM.splice(_index, 1);
      }
    }
    lastIdentifiers = newLastIdentifiers;
  };
};

/***/ }),

/***/ 90569:
/***/ ((module) => {

"use strict";


var memo = {};

/* istanbul ignore next  */
function getTarget(target) {
  if (typeof memo[target] === "undefined") {
    var styleTarget = document.querySelector(target);

    // Special case to return head of iframe instead of iframe itself
    if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
      try {
        // This will throw an exception if access to iframe is blocked
        // due to cross-origin restrictions
        styleTarget = styleTarget.contentDocument.head;
      } catch (e) {
        // istanbul ignore next
        styleTarget = null;
      }
    }
    memo[target] = styleTarget;
  }
  return memo[target];
}

/* istanbul ignore next  */
function insertBySelector(insert, style) {
  var target = getTarget(insert);
  if (!target) {
    throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
  }
  target.appendChild(style);
}
module.exports = insertBySelector;

/***/ }),

/***/ 19216:
/***/ ((module) => {

"use strict";


/* istanbul ignore next  */
function insertStyleElement(options) {
  var element = document.createElement("style");
  options.setAttributes(element, options.attributes);
  options.insert(element, options.options);
  return element;
}
module.exports = insertStyleElement;

/***/ }),

/***/ 3565:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


/* istanbul ignore next  */
function setAttributesWithoutAttributes(styleElement) {
  var nonce =  true ? __webpack_require__.nc : 0;
  if (nonce) {
    styleElement.setAttribute("nonce", nonce);
  }
}
module.exports = setAttributesWithoutAttributes;

/***/ }),

/***/ 7795:
/***/ ((module) => {

"use strict";


/* istanbul ignore next  */
function apply(styleElement, options, obj) {
  var css = "";
  if (obj.supports) {
    css += "@supports (".concat(obj.supports, ") {");
  }
  if (obj.media) {
    css += "@media ".concat(obj.media, " {");
  }
  var needLayer = typeof obj.layer !== "undefined";
  if (needLayer) {
    css += "@layer".concat(obj.layer.length > 0 ? " ".concat(obj.layer) : "", " {");
  }
  css += obj.css;
  if (needLayer) {
    css += "}";
  }
  if (obj.media) {
    css += "}";
  }
  if (obj.supports) {
    css += "}";
  }
  var sourceMap = obj.sourceMap;
  if (sourceMap && typeof btoa !== "undefined") {
    css += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))), " */");
  }

  // For old IE
  /* istanbul ignore if  */
  options.styleTagTransform(css, styleElement, options.options);
}
function removeStyleElement(styleElement) {
  // istanbul ignore if
  if (styleElement.parentNode === null) {
    return false;
  }
  styleElement.parentNode.removeChild(styleElement);
}

/* istanbul ignore next  */
function domAPI(options) {
  if (typeof document === "undefined") {
    return {
      update: function update() {},
      remove: function remove() {}
    };
  }
  var styleElement = options.insertStyleElement(options);
  return {
    update: function update(obj) {
      apply(styleElement, options, obj);
    },
    remove: function remove() {
      removeStyleElement(styleElement);
    }
  };
}
module.exports = domAPI;

/***/ }),

/***/ 44589:
/***/ ((module) => {

"use strict";


/* istanbul ignore next  */
function styleTagTransform(css, styleElement) {
  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css;
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild);
    }
    styleElement.appendChild(document.createTextNode(css));
  }
}
module.exports = styleTagTransform;

/***/ }),

/***/ 70051:
/***/ ((module) => {

"use strict";
module.exports = require("@ba/ba-graphics/dist/icons-js/arrow--left_16");

/***/ }),

/***/ 68779:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 38213:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 97880:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 98060:
/***/ ((module) => {

"use strict";
module.exports = require("css-loader/lib/css-base");

/***/ }),

/***/ 580:
/***/ ((module) => {

"use strict";
module.exports = require("prop-types");

/***/ }),

/***/ 16689:
/***/ ((module) => {

"use strict";
module.exports = require("react");

/***/ }),

/***/ 32477:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__32477__;

/***/ }),

/***/ 56685:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__56685__;

/***/ }),

/***/ 78815:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__78815__;

/***/ })

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ var __webpack_exports__ = (__webpack_exec__(76854));
/******/ return __webpack_exports__;
/******/ }
]);
});